import React, { useState } from "react";
import EmployeeRightPanel from "./EmployeeRightPanel";

const employeePanelStorageKey = "webcrm.employeePanelCollapsed";

const WorkspaceLayout = ({ children }) => {
    const [isEmployeePanelCollapsed, setIsEmployeePanelCollapsed] = useState(() => {
        try {
            return window.localStorage.getItem(employeePanelStorageKey) === "true";
        } catch (error) {
            return false;
        }
    });

    const toggleEmployeePanel = () => {
        setIsEmployeePanelCollapsed((value) => {
            const nextValue = !value;
            try {
                window.localStorage.setItem(employeePanelStorageKey, String(nextValue));
            } catch (error) {
                // Ignore storage failures; the layout toggle should still work.
            }
            return nextValue;
        });
    };

    return (
        <div className={`workspace-layout ${isEmployeePanelCollapsed ? "is-employee-panel-collapsed" : ""}`}>
            <EmployeeRightPanel
                isCollapsed={isEmployeePanelCollapsed}
                onToggleCollapsed={toggleEmployeePanel}
            />
            <div className="workspace-content">
                {children}
            </div>
        </div>
    );
};

export default WorkspaceLayout;
